import styled from 'styled-components';

export const StyledLogo = styled.img`
    pointer-events: none;
`;
